module.exports = __webpack_public_path__ + "img/link_1.01285e07.jpg";